import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import c from 'classnames';
import styles from './Modal.css';
import { ClickElement } from '../form';
import { ItemViewPage } from '../pages';

export const Modal = ({ staticContext }) => {
  const location = useLocation();
  const history = useHistory();

  const backUrlOnClose = () => {
    history.push(location.pathname);
  };

  useEffect(() => {
    document.body.classList.add(styles.noscroll);
    return () => document.body.classList.remove(styles.noscroll);
  }, []);

  const Side = () => <div
    className={styles.side}
    onClick={() => backUrlOnClose() } >
  </div>;

  return (
    <section className={c(
      styles.modal,
      styles.show,
      'modal',
    )}>

      <div className={styles.popup}>
        <div className={c(
          styles.content,
          'popup_content',
        )}>
          <Side />
          <div
            className={styles.header}
            onClick={() => backUrlOnClose() }>
            <ClickElement
              modalclose
              ElementType="button"
              type="submit"
              text={<>Sluiten<FontAwesomeIcon icon={['fas', 'times']} style={{ marginLeft: '5px'}}/></>}
            />
          </div>
          <ItemViewPage staticContext={staticContext} />
        </div>
      </div>
      <Side />
    </section>
  );
};
